import { Injectable } from '@angular/core';
import { BodyPartDto } from '../model/body-part.model';

@Injectable({
  providedIn: 'root',
})
export class BodyPartsService {
  private bpa = {
    testa: 'Testa (ant.)',
    collo: 'Collo',
    spallaSx: 'Spalla sinistra',
    spallaDx: 'Spalla destra',
    torace: 'Torace',
    addome: 'Addome',
    bacino: 'Bacino',
    cosciaDx: 'Coscia destra',
    cosciaSx: 'Coscia sinistra',
    ginocchioSx: 'Ginocchio sinistro (ant.)',
    ginocchioDx: 'Ginocchio destro (ant.)',
    gambaSx: 'Gamba sinistra (ant.)',
    gambaDx: 'Gamba destra (ant.)',
    cavigliaSx: 'Caviglia sinistra (ant.)',
    cavigliaDx: 'Caviglia destra (ant.)',
    piedeSx: 'Piede sx',
    piedeDx: 'Piede dx',
    braccioSx: 'Braccio sinistro (ant.)',
    braccioDx: 'Braccio destro (ant.)',
    gomitoSx: 'Gomito sinistro (ant.)',
    gomitoDx: 'Gomito destro (ant.)',
    avambraccioSx: 'Avambraccio sx (ant.)',
    avambraccioDx: 'Avambraccio destro (ant.)',
    polsoSx: 'Polso sinistro (ant.)',
    polsoDx: 'Polso destro (ant.)',
    manoSx: 'Mano sinistra (ant.)',
    manoDx: 'Mano destra (ant.)',
  };

  private bpp = {
    testa: 'Testa (post.)',
    collo: 'Collo (post)',
    schiena: 'Schiena',
    lombo: 'Lombo',
    natiche: 'Natiche',
    spallaSx: 'Spalla sinistra (post.)',
    spallaDx: 'Spalla dx (post.)',
    braccioSx: 'Braccio sinistro (post.)',
    braccioDx: 'Braccio destro (post.)',
    gomitoSx: 'Gomito sinistro (post.)',
    gomitoDx: 'Gomito destro (post.)',
    avambraccioSx: 'Avambraccio sx (post.)',
    avambraccioDx: 'Avambraccio destro (post.)',
    polsoSx: 'Polso sinistro (post.)',
    polsoDx: 'Polso destro (post.)',
    manoSx: 'Mano sinistra (post.)',
    manoDx: 'Mano destra  (post.)',
    cosciaSx: 'Coscia sinistra (post.)',
    cosciaDx: 'Coscia destra (post.)',
    ginocchioSx: 'Ginocchio sinistro (post.)',
    ginocchioDx: 'Ginocchio destro (post.)',
    polpaccioSx: 'Polpaccio sinistro',
    polpaccioDx: 'Polpaccio destro',
    cavigliaSx: 'Caviglia sinistra (ant.)',
    cavigliaDx: 'Caviglia destra (ant.)',
    piedeSx: 'Piede sinistro (post.)',
    piedeDx: 'Piede destro (post.)',
  };

  /**
   * Restituisce una singola parte del corpo dato il suo ID
   */
  getPartById(id: number): BodyPartDto | undefined {
    return this.getBodyParts().find(part => part.bodyPartId === id);
  }

  getBodyParts(): BodyPartDto[] {
    const bpa = this.bpa;
    const bpp = this.bpp;

    return [
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.testa,
        bodyPartId: 0,
        d: 'M229.1 49.2c-1.6-1-3.4.4-5-1-1.2-1-1-3-1-7v-8c.2-9-5.7-16.5-7-18-2.6-3.3-5.4-5.2-11-9-7-4.8-10.6-5.7-13-6a22.9 22.9 0 00-4.9-.1 22.8 22.8 0 00-4.9.1c-2.3.3-6 1.2-13 6-5.6 3.8-8.3 5.7-11 9a30 30 0 00-7 18v8c.1 4 .3 6-1 7-1.5 1.4-3.3 0-5 1-3.2 2.2-.8 11.2 1 16 .7 1.6 4 10.1 8 10 1.6 0 2-1.3 3-1 2.5.8-.5 9 3 17 2.4 5.3 6.9 8.6 10 11a24.7 24.7 0 007 4 23 23 0 0010 1.2 23 23 0 009.8-1.2 25 25 0 007-4c3.2-2.4 7.7-5.7 10-11 3.6-8 .6-16.2 3-17 1-.3 1.5 1 3 1 4.1.1 7.4-8.4 8-10 1.9-4.8 4.3-13.8 1-16z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.collo,
        bodyPartId: 1,
        d: 'M188.39 109.89 C 183.995 110.424 176.684 108.412 170.97 104.876 C 165.256 101.34 159.834 94.055 159.545 93.516 C 159.256 92.977 164.271 101.623 163.174 107.351 C 162.077 113.079 162.337 121.087 153.995 126.864 C 144.779 133.246 139.147 132.474 131.511 135.233 C 123.875 137.992 118.582 141.192 118.9 141 C 120.951 139.764 150.26 147.525 152.019 147.793 C 153.778 148.061 179.193 146.587 187.216 146.692 C 193.492 146.774 223.588 148.039 224.874 148.164 C 226.16 148.289 238.625 140.074 257.372 141.883 C 258.854 142.026 250.555 137.187 249.105 136.617 C 247.655 136.047 235.779 130.962 228.613 127.628 C 221.447 124.294 214.538 117.632 213.696 107.547 C 212.854 97.462 216.801 92.113 215.61 94.133 C 214.419 96.153 209.698 102.199 202.183 106.264 C 194.668 110.329 193.517 109.267 188.39 109.89 Z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.spallaSx,
        bodyPartId: 2,
        d: 'M232.5 149c0-2 11.5-4.4 20-5 5-.5 7.5-.7 11 0a33.8 33.8 0 0115 7c6.6 5 9.8 10.7 12 15a67 67 0 017 25c.8 7.1 1 8.2.3 9-4 4.5-22.2-.4-29.3-12-3.3-5.7-1.1-7.9-6-16a49.8 49.8 0 00-11-13 41.5 41.5 0 00-9-6c-6.2-3.1-10-3-10-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.spallaDx,
        bodyPartId: 3,
        d: 'M142.9 149c0-2-11.4-4.4-20-5a38 38 0 00-11 0 33.8 33.8 0 00-15 7c-6.6 5-9.8 10.7-12 15a67.1 67.1 0 00-7 25c-.8 7.1-1 8.2-.3 9 4 4.5 22.3-.4 29.3-12 3.3-5.7 1.1-7.9 6-16a49.8 49.8 0 0111-13 41.8 41.8 0 019-6c6.2-3.1 10-3 10-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.torace,
        bodyPartId: 4,
        d: 'm188.84,150.09c27.02,0.24 37.43,-1.82 55.33,7.17c8.77,4.41 21.88,18.47 20.96,36.81c-0.93,18.33 -5.24,33.21 -8.15,47.69c-1.49,7.37 -5.08,21.36 -5.72,24.4c-0.63,3.03 -3.22,18.23 -9.32,22.84c-5.45,4.12 -15.72,1.13 -22.06,-0.93c-6.33,-2.06 -24.52,-4.05 -29.03,-4.16c-4.65,-0.11 -21.31,1.5 -26.21,3.37c-4.91,1.88 -25.16,6.18 -31.4,1.1c-5.8,-4.7 -5.01,-10.03 -7.32,-18.09c-2.3,-8.07 -6.53,-26.13 -7.43,-29.41c-3.43,-12.59 -7.62,-34.47 -8.42,-46.3c-0.8,-11.83 5.33,-26.27 15.47,-33.94c18.2,-13.75 36.29,-10.81 63.31,-10.56z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.addome,
        bodyPartId: 5,
        d: 'M131.644 292.28 C 130.977 288.717 141.615 296.508 154.571 292.628 C 167.527 288.749 182.904 285.852 191.925 286.216 C 197.932 286.459 209.431 288.412 220.36 291.707 C 231.289 295.001 238.803 292.561 243.163 290.694 C 238.752 301.641 241.784 322.898 242.474 334.565 C 243.164 346.232 241.768 349.499 234.685 353.525 C 216.338 367.675 162.522 365.513 146.907 357.797 C 131.292 350.081 132.221 341.163 131.431 334.422 C 130.641 327.681 133.612 302.795 131.644 292.28 Z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.bacino,
        bodyPartId: 6,
        d: 'M229.138 359.686 C 243.49 352.298 244.409 343.885 244.733 345.084 C 245.057 346.283 245.948 348.94 245.704 350.678 C 245.461 352.417 244.167 353.425 241.271 357.024 C 238.374 360.624 231.546 371.562 224.029 381.082 C 216.512 390.602 207.323 411.765 200.171 413.378 C 193.019 414.991 175.47 416.764 167.727 407.167 C 159.983 397.569 152.918 383.823 151.202 381.245 C 148.882 377.759 141.202 366.089 137.204 360.447 C 133.206 354.805 129.398 349.394 129.634 348.887 C 129.977 348.152 130.187 346.966 130.348 346.018 C 130.51 345.07 130.623 344.362 130.772 344.583 C 134.566 350.189 137.157 355.552 144.47 359.576 C 151.781 363.602 163.814 366.291 186.492 366.549 C 209.17 366.808 220.552 364.105 229.138 359.686 Z',
      },

      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.cosciaDx,
        bodyPartId: 7,
        d: 'M117.194 515.785 C 119.551 536.207 123.4 547 126.5 559 C 128.672 567.407 130.8 573.3 135.3 577 C 138.5 579.6 141.5 580 147.7 580.5 C 158.3 581 175.6 583.6 179.3 575.9 C 181.1 572.5 179.8 567.4 179.3 565.1 C 178.826 563.542 179.721 548.663 181.195 538.059 C 186.712 498.371 180.231 418.96 173.579 415.07 C 165.941 410.603 157.757 396.533 151.447 386.354 C 142.82 372.438 132.572 359.406 128.438 352.973 C 122.854 348.067 111.127 488.2 117.194 515.785 Z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.cosciaSx,
        bodyPartId: 8,
        d: 'M257.882 515.916 C 263.948 488.332 252.221 348.198 246.638 353.105 C 242.503 359.538 232.256 372.57 223.629 386.486 C 217.319 396.664 209.135 410.735 201.497 415.201 C 194.845 419.092 188.364 498.502 193.881 538.191 C 195.355 548.795 196.25 563.674 195.775 565.231 C 195.276 567.531 193.976 572.631 195.775 576.032 C 199.475 583.732 216.775 581.132 227.376 580.631 C 233.575 580.132 236.576 579.732 239.776 577.132 C 244.276 573.432 246.403 567.538 248.576 559.132 C 251.675 547.132 255.525 536.338 257.882 515.916',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.ginocchioDx,
        bodyPartId: 9,
        d: 'M128.8 577.2c-2.4.8 1.6 8 3.7 21.6l.7 4.9.2 3c.6 6.7 2 7.8 1.8 12.4 0 3.4-.8 4.5 0 6.6a8.8 8.8 0 003 3.4 12.1 12.1 0 007.2 2.5c1.5 0 1.3-.3 3.8-.5h10a44.3 44.3 0 015 1 31.4 31.4 0 006 1c1.2 0 3.9-.2 5.7-2.2a3.2 3.2 0 00.7-1c.6-1.2-.2-2.8.2-6.2.5-3.1 1.3-2.9 2.8-7.9a60.6 60.6 0 001.9-9.1c.4-2.6.5-4.4.9-7.9 1.3-13 0-10.3 1-13.7.4-2.1 1-3.3 0-4-1.8-1.1-5.5 1-12 2-2.8.5-2.9.2-16.7 0-11.3-.1-12.3 0-14.8-.6-7.3-2-9.3-5.9-11-5.3z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.ginocchioSx,
        bodyPartId: 10,
        d: 'M246.6 577.2c2.4.8-1.6 8-3.7 21.6l-.6 4.9-.3 3c-.6 6.7-1.9 7.8-1.8 12.4 0 3.4.9 4.5 0 6.6a8.8 8.8 0 01-3 3.4 12.1 12.1 0 01-7.2 2.5c-1.4 0-1.2-.3-3.8-.4-1.6-.2-2 0-5 0-3.8 0-3.6-.2-5 0a44.3 44.3 0 00-5 1 31.3 31.3 0 01-6 1c-1.1-.1-3.8-.3-5.7-2.3a3.2 3.2 0 01-.7-.9c-.6-1.3.3-2.9-.2-6.3-.4-3-1.3-2.8-2.8-7.8a60.6 60.6 0 01-1.8-9.2 138 138 0 01-1-7.9c-1.2-13 0-10.3-.8-13.7-.5-2.1-1-3.3 0-4 1.7-1.1 5.4 1 12 2 2.7.5 2.7.2 16.6 0 11.3-.1 12.2 0 14.8-.6 7.2-2 9.2-5.9 11-5.3z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.gambaDx,
        bodyPartId: 11,
        d: 'M135.5 630c-1.6.7-1.4 4-1.8 13-.3 9.2-.6 7-.8 15-.1 3-.3 10.8 0 17 .6 11.6 2.9 12.8 6.1 30 2.5 13 2 16.3 4.5 29s3.7 12.6 3.5 17a5.9 5.9 0 00.9 4c.7.8 2 1.4 7 1a51.6 51.6 0 006.2-1 92.6 92.6 0 0111.5-2 124 124 0 010-29c.8-7 1.5-7.7 2.6-17 .7-6.2.6-6.8 1.8-25 .8-11 1-12.3.9-16 0-8.7-1-8.8-.9-16 .1-9.8 1.8-16.2 0-17-.6-.4-1 .1-2.6 1a28 28 0 01-8 2c-4.4.5-4.7-1.5-10.6-2-7.1-.9-8.5 1.8-13.2 0-4.3-1.8-5.4-4.9-7-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.gambaSx,
        bodyPartId: 12,
        d: 'M240 630c1.5.7 1.3 4 1.7 13 .4 9.2.6 7 .9 15 0 3 .3 10.8 0 17-.6 11.6-3 12.8-6.2 30-2.5 13-2 16.3-4.4 29s-3.8 12.6-3.6 17a5.9 5.9 0 01-.9 4c-.7.8-2 1.4-7 1a51.6 51.6 0 01-6.2-1 92.6 92.6 0 00-11.5-2 124 124 0 000-29c-.8-7-1.5-7.7-2.6-17-.7-6.2-.5-6.8-1.8-25-.7-11-.9-12.3-.9-16 .1-8.7 1-8.8 1-16-.2-9.8-2-16.2 0-17 .5-.4 1 .1 2.6 1a28.1 28.1 0 008 2c4.3.5 4.6-1.5 10.5-2 7.1-.9 8.6 1.8 13.2 0 4.3-1.8 5.5-4.9 7.1-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.cavigliaDx,
        bodyPartId: 13,
        d: 'M172.2 756.4c-1-1.2-3-1-8 0-9.9 1.8-10.4 2.3-13 2-1.6-.2-2.4-.6-3 0-1.2 1.2 1.4 4.4 3 11 .8 3 1.3 5.2 1 8-.3 3-1.3 3.8-2 8-.4 2.4-1.1 6.4 0 7 1.4.6 3.5-4.7 10-9a21.2 21.2 0 0110-4c4.5-.4 7.3 1.1 8 0s-2.4-3-4-8a18.8 18.8 0 01-1-7 18 18 0 000-5c-.2-1.5-.4-2.4-1-3z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.cavigliaSx,
        bodyPartId: 14,
        d: 'M203.2 756.4c1-1.2 3-1 8 0 9.9 1.8 10.4 2.3 13 2 1.6-.2 2.5-.6 3 0 1.2 1.2-1.4 4.4-3 11-.8 3-1.3 5.2-1 8 .3 3 1.3 3.8 2 8 .4 2.4 1.2 6.4 0 7-1.4.6-3.4-4.7-10-9a21.2 21.2 0 00-10-4c-4.4-.4-7.3 1.1-8 0s2.5-3 4-8a18.8 18.8 0 001-7 18 18 0 010-5c.3-1.5.4-2.4 1-3z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.piedeDx,
        bodyPartId: 15,
        d: 'M177.2 783.9c-1-1.7-3.6-2-5-2a14.2 14.2 0 00-6 1 24.6 24.6 0 00-6 3 32.8 32.8 0 00-5 4 17.8 17.8 0 00-5 6 22.3 22.3 0 00-1 4c-.8 3.8-.5 4.3-1 6s-.8 1.6-4 6c-4 5.5-3.4 5.6-5 7-2.1 1.9-3.6 2.2-4 4-.3 1.3.3 2.5 1 4a14.4 14.4 0 004 5c3.6 2.5 6.5-.1 16 0 4.4 0 7.2.9 12 0a12.5 12.5 0 005-2 11.2 11.2 0 004-5 11.3 11.3 0 000-8 42.7 42.7 0 010-20v-4-5c.1-3 .4-3.3 0-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.piedeSx,
        bodyPartId: 16,
        d: 'M198.2 783.9c1-1.7 3.6-2 5-2a14.2 14.2 0 016 1 24.6 24.6 0 016 3 32.8 32.8 0 015 4c2.7 2.5 4.1 3.8 5 6a22.3 22.3 0 011 4c.8 3.8.5 4.3 1 6s.9 1.6 4 6c4 5.5 3.5 5.6 5 7 2.1 1.9 3.6 2.2 4 4 .3 1.3-.3 2.5-1 4a14.4 14.4 0 01-4 5c-3.6 2.5-6.5-.1-16 0-4.4 0-7.2.9-12 0a12.5 12.5 0 01-5-2 11.2 11.2 0 01-4-5 11.3 11.3 0 010-8 42.7 42.7 0 000-20v-4-5c-.1-3-.4-3.3 0-4z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.braccioDx,
        bodyPartId: 17,
        d: 'M107.2 191.9c-1.2-.4-1.8 1.7-6 5a34.7 34.7 0 01-9 5c-4.4 1.7-7 2.7-10 2s-4-2.6-5-2c-1.5.8-.2 5 0 11 .1 2.8-.2 5.9-1 12-1.1 9-1.9 15.4-4 22a28.5 28.5 0 00-2 9.6 23.5 23.5 0 010 4.4c-.5 3.4-1.7 4.6-1 6 .6 1 1.8.9 4 2s3.2 2.3 5 4a36.5 36.5 0 0012 7c3.6 1.2 4 .5 8 2 3.7 1.4 4.7 2.5 6 2 1.9-.7 2-3.7 3-10 1.5-9.3 2-8.1 3-16a103.7 103.7 0 001-12c.2-9.9-1.6-11.5-2-23v-14c0-12.8-.4-16.6-2-17z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.braccioSx,
        bodyPartId: 18,
        d: 'M268.2 191.9c1.2-.4 1.8 1.7 6 5a34.7 34.7 0 009 5c4.4 1.7 7 2.7 10 2s4-2.6 5-2c1.6.8.3 5 0 11-.1 2.8.3 5.9 1 12 1.1 9 1.9 15.4 4 22a28.5 28.5 0 012 9.6 23.5 23.5 0 000 4.4c.5 3.4 1.7 4.6 1 6-.6 1-1.8.9-4 2s-3.2 2.3-5 4a36.5 36.5 0 01-12 7c-3.6 1.2-4 .5-8 2-3.6 1.4-4.7 2.5-6 2-1.9-.7-2-3.7-3-10-1.5-9.3-2-8.1-3-16a103.7 103.7 0 01-1-12c-.2-9.9 1.6-11.5 2-23v-14c0-12.8.5-16.6 2-17z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.gomitoDx,
        bodyPartId: 19,
        d: 'M68.2 268.9c-2.5 1.4-1.4 7.6-1 10a22.1 22.1 0 004.7 10c1.4 1.8 3.4 3.6 12 8 10.5 5.4 15.8 8 18.3 6 1.1-1 1.4-3 2-7 .7-4.6 1-7 0-9-1.9-3.8-7-3-14-5-13.5-4.2-18.5-15-22-13z',
      },
      {
        face: 'ant',
        checked: true,
        name: bpa.gomitoSx,
        bodyPartId: 20,
        subject: ' ',
        content: '',
        d: 'M307.2 268.9c2.5 1.4 1.4 7.6 1 10a22.1 22.1 0 01-4.7 10c-1.4 1.8-3.4 3.6-12 8-10.5 5.4-15.8 8-18.3 6-1.1-1-1.4-3-2-7-.6-4.6-1-7 0-9 1.9-3.8 7-3 14-5 13.6-4.2 18.5-15 22-13z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.avambraccioDx,
        bodyPartId: 21,
        d: 'M65.9 285c-3.6.1-5.8 11.7-8 24-1.7 9-2.6 16.8-3 22-1 11.3-.1 10-1 16-2.2 14.8-7.7 21.7-4 26 1.3 1.4 3.8 2.5 7 4a23.8 23.8 0 006 2c5.6.7 10.4-3 12-4 5.5-4.2 6.6-9 11-19 5-11.5 5-8.7 11-22 9.5-21.3 7.8-24.8 7-26-1.4-2.2-2.4-1.4-16-7-10.3-4.4-12.7-5.9-15-8-4.8-4.6-5-8.2-7-8z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.avambraccioSx,
        bodyPartId: 22,
        d: 'M309.5 285c3.6.1 5.8 11.7 8 24 1.7 9 2.6 16.8 3 22 1 11.3.2 10 1 16 2.2 14.8 7.7 21.7 4 26-1.3 1.4-3.7 2.5-7 4a23.8 23.8 0 01-6 2c-5.6.7-10.4-3-12-4-5.5-4.2-6.6-9-11-19-5-11.5-5-8.7-11-22-9.5-21.3-7.8-24.8-7-26 1.4-2.2 2.4-1.4 16-7 10.3-4.4 12.7-5.9 15-8 4.8-4.6 5-8.2 7-8z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.polsoDx,
        bodyPartId: 23,
        d: 'M47.9 375c-3.5 1.3-.8 8.3-6 18-2 3.5-3.8 5.2-3 7 .9 2 4 1.1 11 3s8.3 3.8 12 3a12.3 12.3 0 006-4 13.1 13.1 0 002-4c1.6-4.6 1.2-6.7 2-10 1.5-6.7 5-8.7 4-10-1.5-2.2-8.5 3.9-17 2-6.4-1.6-8.1-6.2-11-5z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.polsoSx,
        bodyPartId: 24,
        d: 'M327.5 375c3.6 1.3.8 8.3 6 18 2 3.5 3.8 5.2 3 7-.9 2-4 1.1-11 3s-8.3 3.8-12 3a12.3 12.3 0 01-6-4 13.1 13.1 0 01-2-4c-1.5-4.6-1.2-6.7-2-10-1.4-6.7-5-8.7-4-10 1.5-2.2 8.5 3.9 17 2 6.5-1.6 8.2-6.2 11-5z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.manoDx,
        bodyPartId: 25,
        d: 'M41.5 403.8a17.7 17.7 0 00-4.6 0c-3.2.6-5.3 2.6-9.4 6.5-2.9 2.8-2.9 3.3-5.6 5.6l-4.6 3.7c-4 3.2-3.7 3.4-5.6 4.7-3 2-4.4 3-6.5 3.7-2.5.8-3.9.6-4.7 1.9a3.7 3.7 0 000 3.7c1.4 2.4 5.5 2.6 8.4 1.9 4-1 7-4.2 8.4-5.6 1.9-2 3.3-4.1 4.6-3.7a1.7 1.7 0 011 .9c1.1 2.1-.3 5-1 6.5-2.6 5.8-.7 4.6-3.7 11.2-1.5 3.4-2.5 4.5-4.5 7.7a51 51 0 00-3 5.4C9 461.5 8.1 463.5 9 465a4.1 4.1 0 004 2c1.6-.2 2.5-1.6 4-4a81 81 0 005-9.9c1-2.3 2.2-4.6 4.7-9.3.7-1.4 1.9-3.7 3.3-3.6a1.8 1.8 0 011.3.8 2.3 2.3 0 010 1.8 64.7 64.7 0 01-3.7 8.4l-1.9 3.8-3.7 8.4-2 4.6c-1.2 3.7-2 5.8-1 7s4.1 1.2 6 0c1.7-1 1.7-2.3 4-8l3.3-7.4 2.8-7.4c1.5-5 2-8.2 3.7-8.4a2.2 2.2 0 011.8 1c1 1 .5 2.6 0 4.6-.7 3-1.2 6.2-1.8 9.3l-1 5.6a30.9 30.9 0 00-.8 6.7c.1 2 .2 3 1 4a3.6 3.6 0 004 1 3.5 3.5 0 002-3 52 52 0 001-6l.3-3.6c.2-2.5.5-5.7 1-9.4a40.8 40.8 0 011.8-7.4c.4-1.3.8-2.5 1.9-2.8a2.4 2.4 0 012.8 1 6.5 6.5 0 010 1.8 36.5 36.5 0 00-1 7.4v1.9c0 6-.6 7 .2 8.1a4.2 4.2 0 005 1c1.3-.8 1.3-2.5 1.4-8.2v-8.4a125.9 125.9 0 011-13c.7-7 1-10.5 1.8-14 1.3-6.3 2.6-9 1-11.2-.8-1-2.4-1.5-5.7-2.8a58.5 58.5 0 00-5.6-1.9 42.9 42.9 0 00-9.4-1.8z',
      },
      {
        face: 'ant',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpa.manoSx,
        bodyPartId: 26,
        d: 'M333.9 403.8a17.7 17.7 0 014.7 0c3.1.6 5.2 2.6 9.3 6.5 2.9 2.8 2.9 3.3 5.6 5.6l4.6 3.7c4 3.2 3.7 3.4 5.6 4.7 3 2 4.4 3 6.6 3.7 2.4.8 3.8.6 4.6 1.9a3.7 3.7 0 010 3.7c-1.3 2.4-5.5 2.6-8.4 1.9-4-1-7-4.2-8.4-5.6-1.8-2-3.3-4.1-4.6-3.7a1.7 1.7 0 00-1 .9c-1.1 2.1.3 5 1 6.5 2.6 5.8.7 4.6 3.7 11.2 1.5 3.4 2.5 4.5 4.5 7.7a53.3 53.3 0 013 5.4c1.7 3.6 2.6 5.6 1.8 7.2a4.1 4.1 0 01-4 2c-1.6-.2-2.6-1.6-4-4a81 81 0 01-5-9.9c-1-2.3-2.2-4.6-4.7-9.3-.7-1.4-1.9-3.7-3.3-3.6a1.8 1.8 0 00-1.3.8 2.3 2.3 0 000 1.8 64.7 64.7 0 003.7 8.4l1.9 3.8 3.7 8.4 2 4.6c1.2 3.7 2 5.8 1 7s-4.1 1.2-6 0c-1.7-1-1.7-2.3-4-8l-3.3-7.4-2.8-7.4c-1.5-5-2-8.2-3.7-8.4a2.2 2.2 0 00-1.8 1c-1 1-.5 2.6 0 4.6.7 3 1.2 6.2 1.8 9.3l1 5.6a30.9 30.9 0 01.8 6.7c-.1 2-.2 3-1 4a3.6 3.6 0 01-4 1 3.5 3.5 0 01-2-3 52 52 0 01-1-6l-.3-3.6c-.2-2.5-.5-5.7-1-9.4a40.8 40.8 0 00-1.8-7.4c-.4-1.3-.8-2.5-1.9-2.8a2.4 2.4 0 00-2.8 1 6.5 6.5 0 000 1.8 36.5 36.5 0 011 7.4v1.9c0 6 .6 7-.2 8.1a4.2 4.2 0 01-5 1c-1.3-.8-1.3-2.5-1.4-8.2v-8.4a125.9 125.9 0 00-1-13c-.7-7-1-10.5-1.8-14-1.3-6.3-2.6-9-1-11.2.8-1 2.4-1.5 5.7-2.8a58.5 58.5 0 015.6-1.9 42.9 42.9 0 019.3-1.8z',
      },
      ///POSTERIORI
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.testa,
        bodyPartId: 27,
        d: 'M 230.2 49.2 C 229.4 48.7 228.55 48.8 227.7 48.85 C 226.85 48.9 226 48.9 225.2 48.2 C 224.6 47.7 224.35 46.95 224.25 45.825 C 224.15 44.7 224.2 43.2 224.2 41.2 L 224.2 37.2 L 224.2 33.2 C 224.057 29.896 223.371 26.662 222.188 23.621 C 221.006 20.58 219.327 17.732 217.2 15.2 C 215.9 13.55 214.55 12.25 212.825 10.888 C 211.1 9.525 209 8.1 206.2 6.2 C 202.7 3.8 200.05 2.375 197.975 1.513 C 195.9 0.65 194.4 0.35 193.2 0.2 C 192.388 0.096 191.57 0.035 190.753 0.018 C 189.935 0.001 189.116 0.029 188.3 0.1 C 187.484 0.029 186.665 0.002 185.847 0.018 C 185.029 0.035 184.212 0.096 183.4 0.2 C 182.25 0.35 180.75 0.65 178.662 1.513 C 176.575 2.375 173.9 3.8 170.4 6.2 C 167.6 8.1 165.5 9.525 163.775 10.888 C 162.05 12.25 160.7 13.55 159.4 15.2 C 157.273 17.732 155.594 20.58 154.412 23.621 C 153.229 26.662 152.543 29.896 152.4 33.2 L 152.4 37.2 L 152.4 41.2 C 152.45 43.2 152.525 44.7 152.425 45.825 C 152.325 46.95 152.05 47.7 151.4 48.2 C 150.65 48.9 149.825 48.9 148.975 48.85 C 148.125 48.8 147.25 48.7 146.4 49.2 C 144.8 50.3 144.6 53.1 145.025 56.225 C 145.45 59.35 146.5 62.8 147.4 65.2 C 147.7 66 148.7 68.525 150.125 70.838 C 151.55 73.15 153.4 75.25 155.4 75.2 C 156.15 75.2 156.6 74.9 157.013 74.625 C 157.425 74.35 157.8 74.1 158.4 74.2 C 160.05 74.45 160.919 77.756 161.834 81.348 C 162.749 84.941 163.709 88.82 165.543 90.217 C 166.722 91.116 167.726 89.539 179.346 86.465 C 190.966 83.391 199.563 86.206 202.711 86.556 C 205.859 86.906 210.579 90.593 213.225 88.965 C 213.725 88.765 219.1 74.35 219.55 74.65 C 220 74.95 220.5 75.3 221.2 75.3 C 223.25 75.3 225.1 73.175 226.513 70.863 C 227.925 68.55 228.9 66.05 229.2 65.3 C 230.15 62.85 231.225 59.35 231.65 56.213 C 232.075 53.075 231.85 50.3 230.2 49.3 L 230.2 49.25 L 230.2 49.2 Z',
      },
      {
        face: 'post',
        checked: true,
        subject: ' ',
        content: ' ',
        name: bpp.collo,
        bodyPartId: 28,
        d: 'M 222.042 117.416 C 218.743 113.879 217.49 113.086 215.746 109.765 C 214.002 106.444 213.024 105.571 212.451 100.418 C 212.056 96.862 211.45 93.074 212.07 92.001 C 212.69 90.928 203.459 89.149 195.892 87.912 C 188.03 86.627 184.725 87.568 182.416 87.963 C 180.107 88.358 168.125 91.404 166.91 92.054 C 165.093 93.026 167.185 93.271 166.661 99.278 C 166.137 105.285 165.823 107.378 164.269 110.162 C 162.715 112.946 160.197 116.017 158.833 117.992 C 157.469 119.967 155.475 121.592 153.007 123.38 C 148.891 126.361 144.497 128.777 140.001 130.99 C 135.504 133.203 130.904 135.213 126.377 137.381 C 126.178 137.476 123.84 138.634 121.436 139.977 C 119.032 141.319 116.562 142.847 116.1 143.682 C 115.937 143.976 116.249 144.116 116.685 144.191 C 117.121 144.267 117.681 144.277 118.016 144.313 C 119.238 144.442 120.466 144.498 121.695 144.538 C 122.924 144.578 124.154 144.601 125.382 144.662 C 133.222 145.054 141.059 145.538 148.898 145.979 C 156.736 146.419 164.576 146.815 172.423 147.032 C 184.283 147.359 196.162 147.195 208.031 146.743 C 219.9 146.291 231.759 145.551 243.579 144.728 C 246.294 144.539 247.991 144.609 251.595 144.054 C 255.199 143.499 256.636 144.22 259.849 143.339 C 261.076 143.002 258.552 141.362 257.06 140.528 C 255.569 139.695 254.913 139.258 253.748 138.747 C 252.481 138.192 247.374 135.211 246.088 134.701 C 244.801 134.191 240.133 131.487 238.013 129.639 C 233.724 125.901 231.764 125.906 229.962 123.807 C 228.16 121.708 223.432 118.906 222.042 117.416 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.schiena,
        bodyPartId: 29,
        d: 'M 192.507 149.951 C 197.336 149.89 223.954 146.471 234.456 149.267 C 241.418 159.264 247.235 160.938 251.1 164.3 C 254.247 166.836 256.95 169.878 259.1 173.3 C 261.183 176.282 262.552 179.704 263.1 183.3 C 263.7 188.6 264.331 192.977 264.056 199.183 C 263.733 206.473 264.393 219.616 261.431 233.1 C 259.469 242.031 255.107 254.13 252.324 265.448 C 249.24 277.989 249.991 286.507 245.971 287.347 C 243.241 287.917 200.05 285.513 189.386 285.634 C 178.722 285.755 126.972 289.659 127.361 287.071 C 129.876 270.334 111.093 243.425 113.281 192.788 C 113.963 176.998 119.079 170.316 122.8 166.649 C 129.926 159.627 137.706 154.923 141.257 149.001 C 142.057 148.501 186.069 150.033 192.507 149.951 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.lombo,
        bodyPartId: 30,
        d: 'M 246.253 290.795 C 232.563 291.52 197.203 288.241 189.368 288.352 C 181.533 288.463 128.288 292.543 128.98 291.132 C 129.28 292.232 131.532 299.497 130.461 303.206 C 129.39 306.915 125.765 365.475 135.654 357.412 C 137.268 356.096 163.478 347.773 174.93 358.445 C 186.382 369.117 199.14 359.685 203.357 355.156 C 207.574 350.627 233.378 349.065 239.909 356.138 C 249.4 366.417 244.133 310.843 244.706 303.206 C 245.279 295.569 248.195 290.692 246.253 290.795 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.natiche,
        bodyPartId: 31,
        d: 'M 230.748 355.071 C 228.06 354.089 210.322 353.071 202.567 361.069 C 198.026 365.753 187.852 372.135 178.846 364.555 C 169.84 356.975 164.086 356.264 161.431 356.228 C 152.018 354.763 135.184 361.089 134.04 364.089 C 132.896 367.089 114.033 416.14 125.786 432.982 C 137.539 449.824 145.94 451.034 146.029 451.199 C 146.656 452.364 166.034 456.232 175.17 452.085 C 184.306 447.938 183.303 448.848 186.66 445.711 C 191.012 441.644 185.211 442.309 191.078 446.934 C 196.945 451.559 216.919 456.464 229.563 451.813 C 242.207 447.162 251.443 434.049 252.715 428.206 C 253.981 422.387 250.529 379.773 243.341 364.43 C 240.491 358.345 235.293 356.731 230.748 355.071 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.spallaSx,
        bodyPartId: 32,
        d: 'M 137.523 147.322 C 137.523 147.322 131.304 147.296 122.804 146.496 C 117.804 146.096 115.304 145.896 111.804 146.496 C 106.302 147.554 101.149 149.959 96.804 153.496 C 90.204 158.496 87.004 164.296 84.804 168.496 C 80.87 176.296 78.493 184.787 77.804 193.496 C 77.004 200.796 76.804 201.796 77.504 202.496 C 81.504 207.096 99.704 202.196 106.804 190.496 C 110.104 184.996 107.904 182.796 112.804 174.496 C 115.7 169.566 119.421 165.168 123.804 161.496 C 126.536 159.12 129.56 157.104 132.804 155.496 C 139.004 152.496 137.523 148.522 137.523 147.322 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.spallaDx,
        bodyPartId: 33,
        d: 'M 238.681 147.226 C 238.681 147.226 244.9 147.2 253.4 146.4 C 258.4 146 260.9 145.8 264.4 146.4 C 269.902 147.458 275.055 149.863 279.4 153.4 C 286 158.4 289.2 164.2 291.4 168.4 C 295.334 176.2 297.711 184.691 298.4 193.4 C 299.2 200.7 299.4 201.7 298.7 202.4 C 294.7 207 276.5 202.1 269.4 190.4 C 266.1 184.9 268.3 182.7 263.4 174.4 C 260.504 169.47 256.783 165.072 252.4 161.4 C 249.668 159.024 246.644 157.008 243.4 155.4 C 237.2 152.4 238.681 148.426 238.681 147.226 Z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.braccioSx,
        bodyPartId: 34,
        d: 'M107 194.4c-1.2-.3-1.8 1.8-6 5a34.4 34.4 0 01-9 5c-4.4 1.7-7 2.8-10 2s-4-2.6-5-2c-1.6.8-.3 5 0 11 .1 2.9-.3 6-1 12a116 116 0 01-4 22 28.5 28.5 0 00-2 9.7 23.4 23.4 0 010 4.3c-.5 3.4-1.7 4.6-1 6 .6 1.1 1.8 1 4 2s3.2 2.4 5 4a36.3 36.3 0 0012 7c3.6 1.2 4 .5 8 2 3.6 1.4 4.7 2.5 6 2 1.9-.7 2-3.6 3-10 1.5-9.3 2-8.1 3-16a103.5 103.5 0 001-12c.2-9.8-1.6-11.4-2-23v-14c0-12.7-.5-16.6-2-17z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.braccioDx,
        bodyPartId: 35,
        d: 'M269.1 194.4c1.2-.3 1.8 1.8 6 5a34.8 34.8 0 009 5c4.4 1.7 7 2.8 10 2s4-2.6 5-2c1.6.8.3 5 0 11-.1 2.9.3 6 1 12 1.1 9 1.9 15.4 4 22a28.5 28.5 0 012 9.7 24.3 24.3 0 000 4.3c.5 3.4 1.7 4.6 1 6-.6 1.1-1.8 1-4 2s-3.2 2.4-5 4a36.3 36.3 0 01-12 7c-3.6 1.2-4 .5-8 2-3.6 1.4-4.7 2.5-6 2-1.9-.7-2-3.6-3-10-1.5-9.3-2-8.1-3-16a103.5 103.5 0 01-1-12c-.2-9.8 1.6-11.4 2-23v-14c0-12.7.4-16.6 2-17z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.gomitoSx,
        bodyPartId: 36,
        d: 'M68 271.4c-2.5 1.4-1.4 7.7-1 10a22 22 0 004.7 10c1.4 1.8 3.4 3.7 12 8 10.5 5.4 15.8 8 18.3 6 1.1-.9 1.4-3 2-7 .7-4.5 1-7 0-9-1.9-3.8-7-3-14-5-13.5-4.1-18.5-15-22-13z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.gomitoDx,
        bodyPartId: 37,
        d: 'M308.1 271.4c2.5 1.4 1.4 7.7 1 10a22 22 0 01-4.7 10c-1.4 1.8-3.3 3.7-12 8-10.5 5.4-15.8 8-18.3 6-1.1-.9-1.4-3-2-7-.7-4.5-1-7 0-9 1.9-3.8 7-3 14-5 13.5-4.1 18.5-15 22-13z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.avambraccioSx,
        bodyPartId: 38,
        d: 'M65.7 287.4c-3.6.3-5.8 11.8-8 24-1.7 9.2-2.6 17-3 22-1 11.5-.1 10.1-1 16-2.2 15-7.7 21.9-4 26 1.3 1.6 3.8 2.6 7 4a23 23 0 006 2c5.6.8 10.4-2.8 12-4 5.5-4 6.6-8.9 11-19 5-11.4 5-8.6 11-22 9.5-21.2 7.8-24.7 7-26-1.4-2.1-2.4-1.3-16-7-10.3-4.2-12.7-5.7-15-8-4.8-4.5-5-8-7-8z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.avambraccioDx,
        bodyPartId: 39,
        d: 'M310.4 287.4c3.6.3 5.8 11.8 8 24 1.7 9.2 2.6 17 3 22 1 11.5.2 10.1 1 16 2.2 15 7.7 21.9 4 26a20.9 20.9 0 01-7 4 23 23 0 01-6 2c-5.6.8-10.4-2.8-12-4-5.5-4-6.6-8.9-11-19-5-11.4-5-8.6-11-22-9.5-21.2-7.8-24.7-7-26 1.4-2.1 2.4-1.3 16-7 10.3-4.2 12.7-5.7 15-8 4.8-4.5 5-8 7-8z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.polsoSx,
        bodyPartId: 40,
        d: 'M47.7 377.4c-3.6 1.4-.8 8.4-6 18-2 3.6-3.8 5.3-3 7 .9 2.1 4 1.2 11 3s8.3 4 12 3a12.3 12.3 0 006-4 13.1 13.1 0 002-4c1.6-4.5 1.2-6.6 2-10 1.4-6.5 5-8.6 4-10-1.5-2-8.5 4-17 2-6.4-1.4-8.2-6.1-11-5z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.polsoDx,
        bodyPartId: 41,
        d: 'M328.4 377.4c3.6 1.4.8 8.4 6 18 2 3.6 3.8 5.3 3 7-.9 2.1-4 1.2-11 3s-8.3 4-12 3a12.1 12.1 0 01-6-4 12.7 12.7 0 01-2-4c-1.5-4.5-1.2-6.6-2-10-1.4-6.5-5-8.6-4-10 1.5-2 8.5 4 17 2 6.4-1.4 8.2-6.1 11-5z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.manoSx,
        bodyPartId: 42,
        d: 'M41.5 406a17.7 17.7 0 00-4.6 0c-3.2.6-5.3 2.6-9.4 6.5-2.9 2.8-2.9 3.3-5.6 5.6l-4.6 3.7c-4 3.2-3.7 3.4-5.6 4.7-3 2-4.4 3-6.5 3.7-2.5.8-3.9.7-4.7 2a3.7 3.7 0 000 3.6c1.4 2.4 5.5 2.6 8.4 2 4-1 7-4.3 8.4-5.7 1.9-2 3.3-4.1 4.6-3.7a1.7 1.7 0 011 1c1.1 2-.3 5-1 6.4-2.6 5.9-.7 4.7-3.7 11.2-1.5 3.4-2.5 4.5-4.5 7.8a51.4 51.4 0 00-3 5.3c-1.7 3.6-2.6 5.6-1.7 7.2a4.1 4.1 0 004 2c1.6-.2 2.5-1.5 4-4a81.8 81.8 0 005-9.9c1-2.3 2.2-4.6 4.7-9.3.7-1.3 1.9-3.7 3.3-3.6a1.7 1.7 0 011.3.8 2.3 2.3 0 010 1.9 64.4 64.4 0 01-3.7 8.4l-1.9 3.7c-.9 1.9-1.3 2.7-3.7 8.4l-2 4.6c-1.2 3.7-2 5.8-1 7s4.1 1.3 6 0c1.7-1 1.7-2.3 4-8 1.6-3.8 1.7-3.3 3.3-7.4.9-2.3 1.8-4.4 2.8-7.4 1.5-5 2-8.2 3.7-8.4a2.2 2.2 0 011.8 1c1 1 .5 2.7 0 4.6-.7 3-1.2 6.2-1.8 9.3l-1 5.6a30.8 30.8 0 00-.8 6.7c.1 2 .2 3 1 4a3.7 3.7 0 004 1 3.5 3.5 0 002-3 52.9 52.9 0 001-6l.3-3.6c.2-2.5.5-5.7 1-9.3a41 41 0 011.8-7.5c.4-1.3.8-2.4 1.9-2.8a2.4 2.4 0 012.8 1 6.5 6.5 0 010 1.8 36.6 36.6 0 00-1 7.5v1.8c0 6-.6 7 .2 8.1a4.2 4.2 0 005 1c1.3-.8 1.3-2.5 1.4-8.2v-8.3a125.9 125.9 0 011-13.1c.7-7 1-10.5 1.8-14 1.3-6.3 2.6-9 1-11.2-.8-1-2.4-1.5-5.7-2.8a58.5 58.5 0 00-5.6-1.9 42.9 42.9 0 00-9.4-1.8z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.manoDx,
        bodyPartId: 43,
        d: 'M334.6 406a17.7 17.7 0 014.6 0c3.2.6 5.3 2.6 9.4 6.5 2.9 2.8 2.9 3.3 5.5 5.6 1.6 1.4 1.9 1.4 4.7 3.7 4 3.2 3.7 3.4 5.6 4.7 3 2 4.4 3 6.5 3.7 2.5.8 3.9.7 4.7 2a3.8 3.8 0 010 3.6c-1.4 2.4-5.6 2.6-8.4 2-4-1-7-4.3-8.4-5.7-1.9-2-3.4-4.1-4.7-3.7a1.7 1.7 0 00-.9 1c-1.1 2 .3 5 1 6.4 2.6 5.9.7 4.7 3.7 11.2 1.5 3.4 2.5 4.5 4.5 7.8a55.5 55.5 0 013 5.3c1.7 3.7 2.6 5.6 1.7 7.2a4.1 4.1 0 01-4 2c-1.5-.2-2.5-1.5-4-4a81.8 81.8 0 01-5-9.9c-1-2.3-2.2-4.6-4.6-9.3-.7-1.3-2-3.6-3.4-3.6a1.7 1.7 0 00-1.3.8 2.3 2.3 0 000 1.9 63.8 63.8 0 003.7 8.4l1.9 3.7c.9 1.8 1.3 2.7 3.7 8.4l2 4.6c1.3 3.7 2 5.8 1 7s-4 1.3-6 0c-1.6-1-1.7-2.3-4-8-1.6-3.8-1.6-3.3-3.2-7.3-1-2.4-1.8-4.5-2.8-7.5-1.6-5-2-8.2-3.7-8.4a2.2 2.2 0 00-1.9 1c-.9 1-.4 2.7 0 4.6l1.9 9.3 1 5.6a31.3 31.3 0 01.7 6.8c0 1.9-.1 3-1 4a3.7 3.7 0 01-4 1 3.5 3.5 0 01-2-3 52.9 52.9 0 01-1-6l-.3-3.7c-.1-2.5-.4-5.6-.9-9.3a41.3 41.3 0 00-1.8-7.5c-.5-1.3-.9-2.4-2-2.8a2.4 2.4 0 00-2.7 1 6.5 6.5 0 000 1.8 35.9 35.9 0 011 7.5v1.8c0 6 .6 7-.3 8.2a4.2 4.2 0 01-5 1c-1.2-.8-1.3-2.6-1.3-8.2v-8.4a128.6 128.6 0 00-1-13c-.7-7-1-10.6-1.8-14-1.3-6.4-2.6-9.2-1-11.3.8-.9 2.4-1.5 5.7-2.8a58.5 58.5 0 015.6-1.8 42.9 42.9 0 019.3-1.9z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.cosciaSx,
        bodyPartId: 44,
        d: 'M133 445.7c-6.8-6.6-7-7.6-8-7.4-6.4 1.4-7.2 32.4-7.3 33.7v4.3c0 4.6 0 12.8 2.7 40.4 1.7 18.9 3 29.7 6.1 42.7 2.2 9.2 4.3 15.5 8.8 19.6 3.2 2.7 6.2 3.3 12.4 3.6 19.1 1.2 28.7 1.7 31.6-4.9 1.7-3.9-.1-5.9 0-18.3.1-10 1.4-14 2.7-24.4 1.3-10.8.8-17.6 1.7-36.7a248.7 248.7 0 012.6-28c.3-3.9.6-5.8.7-6.8 0-1.7 1-10-2-12.2-2.3-1.6-5 1.7-13 4a44.8 44.8 0 01-20 1c-3.3-.5-6.4-1-10-3-1.3-.7-3-1.8-9-7.6z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.cosciaDx,
        bodyPartId: 45,
        d: 'M243.1 445.7c6.8-6.6 7-7.6 8-7.4 6.4 1.4 7.2 32.4 7.3 33.7v4.3c0 4.6 0 12.8-2.6 40.4-1.8 18.9-3.1 29.7-6.2 42.7-2.1 9.2-4.2 15.5-8.8 19.6-3.1 2.7-6.1 3.3-12.3 3.6-19.2 1.2-28.8 1.7-31.7-4.9-1.7-3.9.2-5.9 0-18.3 0-10-1.3-14-2.6-24.4-1.3-10.8-.9-17.6-1.8-36.7a244.8 244.8 0 00-2.5-28c-.3-3.9-.7-5.8-.7-6.8-.1-1.7-1.1-10 1.9-12.2 2.3-1.6 5.1 1.7 13 4a44.8 44.8 0 0020 1c3.4-.5 6.5-1 10-3 1.3-.7 3-1.8 9-7.6z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.ginocchioSx,
        bodyPartId: 46,
        d: 'M130 579.2c-2.3.8 1.7 8 3.8 21.6l.6 4.9.3 3c.6 6.7 1.9 7.8 1.8 12.4-.1 3.4-.9 4.5 0 6.6a8.8 8.8 0 003 3.4 12 12 0 007.2 2.5c1.4 0 1.2-.3 3.8-.5h10a44.3 44.3 0 015 1 31.4 31.4 0 006 1c1.2 0 3.9-.2 5.7-2.2a3.3 3.3 0 00.7-1c.6-1.3-.3-2.9.2-6.2.4-3.2 1.3-3 2.8-8a60.4 60.4 0 001.8-9 69.5 69.5 0 001-8l-.7-10.5a28 28 0 00-1-6c-.7-2.4-1-3.7-2-4-1.7-.4-3 3.9-7.4 4.8a9.6 9.6 0 01-1.4.2c-1.9.2-4 0-15.2-.2s-12.3 0-14.8-.6c-7.3-1.9-9.4-5.8-11.1-5.2z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.ginocchioDx,
        bodyPartId: 47,
        d: 'M246 579.2c2.4.8-1.6 8-3.7 21.6l-.6 4.9-.3 3c-.6 6.7-1.9 7.8-1.8 12.4.1 3.4.9 4.5 0 6.6a8.7 8.7 0 01-3 3.4 12 12 0 01-7.2 2.5c-1.5 0-1.2-.3-3.8-.5h-10a44.3 44.3 0 00-5 1 31.4 31.4 0 01-6 1c-1.2 0-3.9-.2-5.7-2.2a3.3 3.3 0 01-.7-1c-.6-1.3.2-2.9-.2-6.2-.5-3.2-1.3-3-2.8-8a60.4 60.4 0 01-1.8-9 72 72 0 01-1-8l.7-10.5a28 28 0 011-6c.7-2.4 1-3.7 2-4 1.7-.4 3 3.9 7.4 4.8a9.8 9.8 0 001.4.2c1.9.2 4 0 15.2-.2s12.3 0 14.8-.6c7.3-1.9 9.4-5.8 11.1-5.2z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.polpaccioSx,
        bodyPartId: 48,
        d: 'M135.3 632.4c-1.6.8-1.4 4.1-1.8 13-.3 9.3-.6 7-.8 15-.1 3-.4 10.9 0 17 .6 11.7 2.9 13 6.1 30 2.5 13 2 16.5 4.5 29s3.7 12.8 3.5 17c0 .9-.2 2.8.9 4 .7 1 2 1.5 7 1a47.3 47.3 0 006.2-1 96.6 96.6 0 0111.5-2 124 124 0 010-29c.8-7 1.5-7.5 2.6-17 .7-6 .5-6.7 1.8-25 .7-10.9 1-12.1.9-16-.1-8.6-1-8.7-1-16 .2-9.6 2-16 0-17-.5-.2-1 .3-2.6 1a28.1 28.1 0 01-7.9 2c-4.4.6-4.7-1.3-10.6-2-7.1-.7-8.5 2-13.2 0-4.3-1.6-5.5-4.8-7.1-4z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.polpaccioDx,
        bodyPartId: 49,
        d: 'M240.8 632.4c1.6.8 1.4 4.1 1.8 13 .4 9.3.6 7 .9 15 0 3 .3 10.9 0 17-.6 11.7-3 13-6.2 30-2.5 13-2 16.5-4.4 29s-3.8 12.8-3.6 17c0 .9.2 2.8-.9 4-.7 1-2 1.5-7 1a47.6 47.6 0 01-6.2-1 96.7 96.7 0 00-11.5-2 125.2 125.2 0 000-29c-.8-7-1.5-7.5-2.6-17-.7-6-.5-6.7-1.8-25-.7-10.9-.9-12.1-.9-16 .1-8.6 1-8.7 1-16-.2-9.6-2-16 0-17 .5-.2 1 .3 2.6 1a28.2 28.2 0 008 2c4.3.6 4.6-1.3 10.5-2 7.1-.7 8.6 2 13.2 0 4.3-1.6 5.5-4.8 7.1-4z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.cavigliaSx,
        bodyPartId: 50,
        d: 'M172 758.9c-1-1.2-3-1-8 0-9.9 1.8-10.4 2.3-13 2-1.6-.2-2.5-.5-3 0-1 1 .3 3.5 3 11a62.7 62.7 0 012 6.4 38 38 0 011 7c.3 6.7-1.9 10.6-1 11 1.3.7 4.7-8.6 12-10a11.7 11.7 0 017 1c3 1.5 4.8 4 8 9 2.7 4.2 3.4 6.2 4 6 .8-.2.9-5.2-1-10-2.8-7-7.4-7.4-9-14a40 40 0 01-1-7V767a21.3 21.3 0 000-5c-.3-1.5-.4-2.4-1-3z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.cavigliaDx,
        bodyPartId: 51,
        d: 'M204.1 758.9c1-1.2 3-1 8 0 9.9 1.8 10.4 2.3 13 2 1.6-.2 2.5-.5 3 0 1 1-.3 3.5-3 11a65.5 65.5 0 00-2 6.4 38 38 0 00-1 7c-.3 6.7 1.9 10.6 1 11-1.3.7-4.7-8.6-12-10a11.7 11.7 0 00-7 1c-3 1.5-4.8 4-8 9-2.7 4.2-3.4 6.2-4 6-.8-.2-.9-5.2 1-10 2.8-7 7.4-7.4 9-14a40 40 0 001-7V767a21.3 21.3 0 010-5c.3-1.5.4-2.4 1-3z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.piedeSx,
        bodyPartId: 52,
        d: 'M173 791.3a10.9 10.9 0 00-5-2c-3.9-.3-6.9 2.1-8 3-3 2.5-6 7-6 12 0 2.9 1 4.4 0 7a10.2 10.2 0 01-3 4c-2.6 2.4-4.5 2-6 4a6.4 6.4 0 00-1 6c.3.7 1.3 2.6 8 4 5 1.1 6 .4 11 1 8.2 1 9.9 3.4 14 2a11.7 11.7 0 006-5c1.3-2.3 1.3-4.4 1-9-.7-9.5-1-14.2-3-18a23.6 23.6 0 00-8-9z',
      },
      {
        face: 'post',
        checked: false,
        subject: ' ',
        content: ' ',
        name: bpp.piedeDx,
        bodyPartId: 53,
        d: 'M203.1 791.3a10.9 10.9 0 015-2c3.9-.3 6.9 2.1 8 3 3 2.5 6 7 6 12 0 2.9-1 4.4 0 7a10.2 10.2 0 003 4c2.6 2.4 4.5 2 6 4a6.4 6.4 0 011 6c-.3.7-1.3 2.6-8 4-5 1.1-6 .4-11 1-8.2 1-9.9 3.4-14 2a11.7 11.7 0 01-6-5c-1.3-2.3-1.3-4.4-1-9 .7-9.5 1-14.2 3-18a23.7 23.7 0 018-9z',
      },
    ];
  }
}
